module.exports = __webpack_public_path__ + "img/agence-01.5b6cd45.jpg";